import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable, inject } from '@angular/core';
import { RegisterUserCommand } from './register-user-command';
import { UrlHelperService } from '@ui/global-shared/util/url-helper.service';

@Injectable({
  providedIn: 'root',
})
export class RegisterUserService {
  private http = inject(HttpClient);
  private urlHelper = inject(UrlHelperService);

  public registerUser(
    user: RegisterUserCommand,
  ): Observable<{ username: string }> {
    return this.http.post<{ username: string }>(
      this.urlHelper.prepareApiPath('signup'),
      user,
    );
  }
}
